<template>
	<div
		class="finance-calc-page"
		:style="{ paddingBottom: car ? safeAreaInsetBottom + 75 + 'px' : 0 }"
	>
		<nio-header-nav
			v-if="isInWebview"
			ref="headerNav"
			:height.sync="headerHeight"
			:is-white="true"
			position="fixed"
			:scroll-listener="true"
			@back="handleClose"
		>
			<template v-slot:center="config">
				<span class="dynamic-title" :class="{ show: config.offset > 40 + 20 }">
					金融计算器
				</span>
			</template>
		</nio-header-nav>

		<nio-pull-refresh
			v-model="pullingRefresh"
			:pull-height="pullHeight"
			:has-more="false"
			:loadMoreStyle="{ display: 'none' }"
			@refresh="handleRefresh"
		>
			<div v-if="car">
				<p class="page-title" :style="{ paddingTop: headerHeight + 20 + 'px' }">金融计算器</p>

				<div class="sub-title">购买车型</div>
				<CarCard :car="car" />

				<div class="sub-title">金融方案</div>
				<ProductTabs v-if="financeTabs.length > 1" v-model="activeFinanceTab" :tabs="financeTabs" />
				<RecommendPlan
					class="recommend-plan"
					v-if="showRecommendPlan"
					:overview-list="recommendOverviewList"
					:details="recommendProduct.detail_infos"
				/>
				<CustomPlan
					v-if="showCustomPlan"
					:customFinances="customProducts"
					:city="currentCity || {}"
					@city-picker-open="isShowAddressList = true"
				/>

				<div class="sub-title">金融流程</div>
				<FinanceProcess />

				<FinanceQA />
			</div>
		</nio-pull-refresh>
		<AddressList :show.sync="isShowAddressList" @input="handleLoanCityChange" />
		<FinanceBottomArea v-if="car" />
	</div>
</template>

<script>
import { supreme } from '@/supreme-core'
import { mapState, mapActions } from 'vuex'
import CarCard from './CarCard.vue'
import RecommendPlan from './FinanceResult.vue'
import CustomPlan from './CustomFinance/Index.vue'
import ProductTabs from './ProductTabs.vue'
import FinanceProcess from './FinanceProcess.vue'
import FinanceQA from './FinanceQA.vue'
import FinanceBottomArea from './FinanceBottomArea.vue'
import AddressList from '@/views1/OrderCreatorPage/AddressList'
import { getSafeInsetTop, getSafeInsetBottom } from '@/util/unit-transfer'
import nativeHybrid from '@/util/nativeHybrid'
import util from '@/util/util'
export default {
	name: 'FinanceCalcPage',
	components: {
		CarCard,
		ProductTabs,
		RecommendPlan,
		CustomPlan,
		FinanceProcess,
		FinanceQA,
		FinanceBottomArea,
		AddressList
	},
	data() {
		return {
			headerHeight: 0,
			activeFinanceTab: 0,
			pullingRefresh: false,
			isShowAddressList: false,
			safeAreaInsetBottom: getSafeInsetBottom(),
			pullHeight: getSafeInsetTop(),
			isInWebview: util.isInWebview()
		}
	},
	computed: {
		...mapState('financeCalcState', ['car', 'currentCity', 'recommendProduct', 'customProducts']),
		financeTabs() {
			const tabs = []
			if (this.recommendProduct) tabs.push('推荐')
			tabs.push('自定义')
			return tabs
		},
		showRecommendPlan() {
			return this.recommendProduct && this.financeTabs[this.activeFinanceTab] === '推荐'
		},
		showCustomPlan() {
			return this.financeTabs[this.activeFinanceTab] === '自定义'
		},
		recommendOverviewList() {
			return [
				{
					amount: this.recommendProduct.loan_payment,
					label: '贷款/融资金额'
				},
				{
					amount: this.recommendProduct.month,
					label: '期数'
				}
			]
		}
	},
	watch: {
		financeTabs(tabs) {
			if (this.activeFinanceTab >= tabs.length) this.activeFinanceTab = 0
		}
	},
	methods: {
		...mapActions('financeCalcState', {
			fetchFinanceData: 'fetchFinanceData',
			changeLoanCity: 'changeLoanCity'
		}),
		async handleLoanCityChange(info) {
			nativeHybrid.showLoading()
			try {
				await this.changeLoanCity(info)
			} catch (error) {
				return
			} finally {
				nativeHybrid.hideLoading()
			}
		},
		async getData(shouldFetchCity = false) {
			nativeHybrid.showLoading()
			try {
				await this.fetchFinanceData({
					skuCode: supreme.getQueryString('sku_code'),
					shouldFetchCity
				})
			} catch (error) {
				// 失败 提示用户
				if (error && error.message === 'car_fetch_failed' && util.isInWebview()) {
					this.$router.push({
						path: '/error'
					})
				}
				return
			} finally {
				this.pullingRefresh = false
				nativeHybrid.hideLoading()
			}
		},
		handleRefresh() {
			this.getData()
		},
		handleClose() {
			nativeHybrid.closeSyn()
		}
	},
	mounted() {
		this.getData(true)
	}
}
</script>

<style scoped lang="scss">
@import '~@nio-fe/nio-app-ui/es/style';

.finance-calc-page {
	box-sizing: border-box;
	background: var(--bg_primary);
	color: $text_primary;

	.page-title {
		@include headline_1(1.2, 400, false);
		padding: 0 20px;
	}
}

::v-deep {
	.dynamic-title {
		opacity: 0;
		transition: opacity 0.2s linear;
	}

	.dynamic-title.show {
		opacity: 1;
	}
}

.sub-title {
	@include subtitle_2(1.5, 500, false);
	padding: 40px 20px 15px;
}

.recommend-plan {
	margin-left: 20px;
	margin-right: 20px;
}
</style>
